import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { blokToComponent } from '../helpers';
import { AnyProps } from '../types';

export const BlackTriangle = ({ blok, getComponent }: AnyProps): JSX.Element => React.createElement('roche-tooltip', {
  icon: 'triangle-down-large',
  text: blok.text,
  title: blok.title,
  // eslint-disable-next-line no-underscore-dangle
  uid: blok._uid,
  getComponent,
});

const getParsedProductName = (productName = ''): string => (typeof productName === 'string'
  ? productName.trim().toLowerCase().replace('®', '')
  : '');

const validateBlackTriangle = (productName, productList = []): boolean => {
  if (!productName) {
    return true;
  }
  // eslint-disable-next-line max-len
  const parsedProductName = getParsedProductName(productName);
  // eslint-disable-next-line max-len
  const product = productList.find((item) => getParsedProductName(item.familyName).includes(parsedProductName)
        || getParsedProductName(item.activeSubstance).includes(parsedProductName));
  return product ? product.blackTriangle : false;
};

/**
 * Replace the [tooltip=tooltip-title] expressions in a string with the
 * JSX tag
 * @param {string} code The string to process
 * @return {string} The processed string
 */
export const InjectBlackTriangle = (code: string,
  pageContext,
  getComponent,
  wrapperTag?: string,
  stripTags = true): string => {
  const tooltipRegExp = /(\S*?)\s?(\[[\s]*blacktriangle([^\][]*)[\s]*\]|▼)/g;
  const blacktriangleElement = '&#9660;';

  // rdr-538-component-allows-html: sanitizing all html borught into this element.
  // const sanitized: HTMLElement = document.createElement('div');
  // sanitized.textContent = blok.headline.toString();
  // TODO::: We cannot use 'document' in the build process. This is the most ideal
  // For now we have to use RegEx solutions which are not perfect

  let replacedCode = code;

  if (stripTags) {
    replacedCode = (code || '').replace(/<[^>]*>/g, '');
    if (wrapperTag) {
      replacedCode = `<${wrapperTag}>${replacedCode}</${wrapperTag}>`;
    }
  }

  if (code && typeof code === 'string') {
    const strippedCode = code.replace(/<[^>]*>/g, '');
    [...strippedCode.matchAll(tooltipRegExp)].forEach((match) => {
      const isValidProduct = validateBlackTriangle(match[1], pageContext.products);
      if (match[2].includes('=')) {
        const matchParams = match[3].replace('=', '').trim().split('|');
        const contactEntry = pageContext?.contacts.find((e) => e.name === matchParams[0]);

        let replaceText = '';

        if (contactEntry) {
          const contactData = JSON.parse(contactEntry.content);
          const tooltipText = `${contactData.firstname} ${contactData.lastname}<br/>
        ${contactData.job_title}

        ${ReactDOMServer.renderToStaticMarkup(
    contactData.slotted_links.map((blok) => blokToComponent({ blok, getComponent }, 'wysiwyg')),
  )}`;
          replaceText = ReactDOMServer.renderToStaticMarkup(<BlackTriangle blok={{
            _uid: contactEntry.uuid,
            text: tooltipText,
            title: contactData.title,
            class: 'black-triangle',
          }}></BlackTriangle>);
        } else {
          replaceText = isValidProduct ? blacktriangleElement : '';
        }
        replacedCode = replacedCode.replace(match[2], replaceText);
      } else {
        const replaceText = isValidProduct ? blacktriangleElement : '';
        replacedCode = replacedCode.replace(match[2], replaceText);
      }
    });
  }

  return replacedCode;
};
